import { useState, useEffect } from "react";
import FeedHeader from "../components/FeedComponents/FeedHeader";
import StoriesBar from "../components/FeedComponents/StoriesBar";
import FeedPost from "../components/FeedComponents/FeedPost";
import BottomNav from "../components/FeedComponents/BottomNav";
import TrialBanner from "../components/TrialComponents/TrialBanner";
import "./Feed.css";

import avChat2 from "../assets/feed/chat2.png";
import avChat1 from "../assets/feed/chat1.png";
import avChat3 from "../assets/feed/chat3.png";
import av1 from "../assets/feed/av-fallback-1.jpg";
import av2 from "../assets/feed/av-fallback-2.jpg";
import av3 from "../assets/feed/av-fallback-3.jpg";
import av4 from "../assets/feed/av-fallback-4.jpg";
import av5 from "../assets/feed/av-fallback-5.jpg";
import av6 from "../assets/feed/av-fallback-6.jpg";
import av7 from "../assets/feed/av-fallback-7.jpg";
import av8 from "../assets/feed/av-fallback-8.jpg";
import av9 from "../assets/feed/av-fallback-9.jpg";
import av10 from "../assets/feed/av-fallback-10.jpg";
import av11 from "../assets/feed/av-fallback-11.jpg";
import av12 from "../assets/feed/av-fallback-12.jpg";
import avatarNicolas from "../assets/feed/avatarnicolas.jpg";
import postagemNicolas from "../assets/feed/postagemnicolas.jpg";

const POSTS = [
  { username: "An*****", avatar: avChat2, postImage: av5, likes: 204, comments: 8, time: "26 de janeiro de 2025", description: "Mais um dia incrível 🌅✨" },
  { username: "Ni*****", avatar: avatarNicolas, postImage: postagemNicolas, likes: 1600000, comments: 34700, time: "24 de janeiro de 2025", imageBlur: 8, avatarBlur: 2 },
  { username: "Br*****", avatar: avChat3, postImage: av8, likes: 312, comments: 5, time: "19 de janeiro de 2025" },
  { username: "Me*****", avatar: av7, postImage: av2, likes: 156, comments: 3, time: "12 de janeiro de 2025" },
  { username: "Pe*****", avatar: av3, postImage: av11, likes: 67, comments: 2, time: "3 de janeiro de 2025" },
  { username: "Th*****", avatar: av9, postImage: av4, likes: 421, comments: 12, time: "28 de dezembro de 2024" },
  { username: "La*****", avatar: av4, postImage: av10, likes: 178, comments: 6, time: "21 de dezembro de 2024" },
  { username: "En*****", avatar: av1, postImage: av6, likes: 95, comments: 1, time: "14 de dezembro de 2024" },
  { username: "Be*****", avatar: av8, postImage: av3, likes: 543, comments: 14, time: "5 de dezembro de 2024" },
  { username: "So*****", avatar: av2, postImage: av9, likes: 267, comments: 7, time: "27 de novembro de 2024" },
  { username: "Le*****", avatar: av5, postImage: av1, likes: 134, comments: 4, time: "18 de novembro de 2024" },
  { username: "Ma*****", avatar: av6, postImage: av12, likes: 389, comments: 9, time: "9 de novembro de 2024" },
  { username: "Ga*****", avatar: av10, postImage: av7, likes: 72, comments: 2, time: "31 de outubro de 2024" },
  { username: "Is*****", avatar: av11, postImage: avChat1, likes: 451, comments: 11, time: "14 de outubro de 2024" },
  { username: "Ra*****", avatar: av12, postImage: avChat2, likes: 213, comments: 5, time: "2 de outubro de 2024" },
];

export default function Feed() {
  const [city, setCity] = useState("");
  const [showNotification, setShowNotification] = useState(false);

  // Dados do perfil
  const profile = JSON.parse(localStorage.getItem('current_profile') || '{}');
  const storedUsername = localStorage.getItem('current_username') || 'usuario';
  
  // Usa a imagem diretamente (pode ser base64 ou URL fallback)
  const avatarUrl = profile.profileImageUrl || av1;

  // Notificação automática
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 5000);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    async function fetchLocation() {
      try {
        const res = await fetch("https://ipapi.co/json/", {
          signal: controller.signal,
        });
        const data = await res.json();
        if (data?.city) {
          setCity(data.city);
          return;
        }
      } catch {}
      try {
        const res = await fetch("https://wtfismyip.com/json", {
          signal: controller.signal,
        });
        const data = await res.json();
        if (data?.YourFuckingLocation) {
          const parts = data.YourFuckingLocation.split(",");
          setCity((parts[0] || "").trim());
        }
      } catch {}
    }
    fetchLocation();
    return () => controller.abort();
  }, []);

  return (
    <div className="feed-page">
      {/* Instagram Notification */}
      {showNotification && (
        <div className="insta-notification">
          <div className="insta-notif-content">
            <div className="insta-notif-icon">
              <svg viewBox="0 0 48 48" fill="none">
                <defs>
                  <linearGradient id="instagramGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{ stopColor: '#833AB4' }} />
                    <stop offset="50%" style={{ stopColor: '#FD1D1D' }} />
                    <stop offset="100%" style={{ stopColor: '#FCB045' }} />
                  </linearGradient>
                </defs>
                <rect width="48" height="48" rx="12" fill="url(#instagramGradient)" />
                <path d="M24 11C17.925 11 13 15.925 13 22C13 28.075 17.925 33 24 33C30.075 33 35 28.075 35 22C35 15.925 30.075 11 24 11ZM24 29C20.134 29 17 25.866 17 22C17 18.134 20.134 15 24 15C27.866 15 31 18.134 31 22C31 25.866 27.866 29 24 29ZM24 17.5C21.519 17.5 19.5 19.519 19.5 22C19.5 24.481 21.519 26.5 24 26.5C26.481 26.5 28.5 24.481 28.5 22C28.5 19.519 26.481 17.5 24 17.5ZM32 10C31.175 10 30.5 10.675 30.5 11.5C30.5 12.325 31.175 13 32 13C32.825 13 33.5 12.325 33.5 11.5C33.5 10.675 32.825 10 32 10Z" fill="white"/>
              </svg>
            </div>
            <div className="insta-notif-text">
              <div className="insta-notif-header">
                <strong>Instagram</strong>
                <span>Agora</span>
              </div>
              <p><strong>{storedUsername}</strong> adivinhou o que vc esqueceu aqui? kkkk</p>
            </div>
            <div className="insta-notif-avatar">
              <img src={avatarUrl} alt={storedUsername} />
            </div>
          </div>
        </div>
      )}

      <FeedHeader />

      <main className="feed-content">
        <StoriesBar />
        {POSTS.map((post, index) => (
          <FeedPost
            key={index}
            username={post.username}
            avatar={post.avatar}
            likes={post.likes}
            comments={post.comments}
            time={post.time}
            blurLevel={index}
            location={index === 0 && city ? city : post.location}
            description={post.description}
            postImage={post.postImage}
            imageBlur={post.imageBlur}
            avatarBlur={post.avatarBlur}
          />
        ))}
      </main>

      <TrialBanner />
      <BottomNav />
    </div>
  );
}